import type { I18N } from '@vista-digital/i18n'
import type { Item, Showtime, Site } from '@vista-digital/ocapi-types/v1'
import { EcommerceShowtimeItem } from '../models-gtm'
import { mapShowTimeData } from './mapShowtimeData'

export const getConcessionEcommerceShowtimeItem = (
    concession: Item,
    showtime: Showtime,
    site: Site,
    i18n: I18N
): EcommerceShowtimeItem => {
    const showtimeDetails = mapShowTimeData(showtime, site, i18n)

    const item = new EcommerceShowtimeItem({
        item_list_name: 'F&B',
        item_list_id: 'f&b',
        item_id: concession.id,
        item_name: i18n.translatable(concession.name),
        item_category: 'F&B',
        item_category4: concession.itemClassId,
        ...showtimeDetails,
    })

    return item
}
